import React, { useState } from 'react';
import '../styles/faq.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      id: 1,
      question: "What is PrepLetter?",
      answer: "PrepLetter is an AI-powered newsletter that delivers carefully curated coding problems directly to your inbox every day. Each PrepLetter contains a detailed problem breakdown, multiple solution approaches, complexity analysis, and practical insights to help you master data structures and algorithms systematically."
    },
    {
      id: 2,
      question: "How much does PrepLetter cost?",
      answer: "PrepLetter is completely free for now! Howver, we are planning to charge for the service in the future to manage the server and emailing cost as the userbase grows."
    },
    {
      id: 3,
      question: "What skill level is PrepLetter suitable for?",
      answer: "PrepLetter is designed for developers of all levels. We follow a structured 6-month journey starting with fundamentals and progressively building complexity. Whether you're a beginner just starting with algorithms or an experienced developer preparing for senior roles, our content adapts to your learning pace."
    },
    {
      id: 4,
      question: "How often will I receive PrepLetters?",
      answer: "You'll receive one PrepLetter daily at your preferred time. You can customize your delivery schedule in your user settings. You an also select how often you want to receive it. But to increase the accountabilty, you'll have to mark each preplletter as completed. Imagine, your class attendence! Haha"
    },
    {
      id: 5,
      question: "What topics does PrepLetter cover?",
      answer: "We cover all essential DSA topics including Arrays, Strings, Linked Lists, Trees, Graphs, Dynamic Programming, Sorting, Searching, and more. Our curriculum follows a carefully designed progression that builds foundational concepts before advancing to complex problem-solving patterns."
    },
    {
      id: 6,
      question: "Can I change my email delivery time?",
      answer: "Yes! You can customize your delivery time in your user preferences. We support all global timezones and let you choose the perfect time that fits your learning schedule - whether it's morning coffee, lunch break, or evening study time."
    },
    {
      id: 7,
      question: "Are there quizzes and interactive features?",
      answer: "Absolutely! Each PrepLetter includes interactive quizzes to test your understanding (Currently only 7 days Milestone quiz are available, we're adding more soon).."
    },
    {
      id: 8,
      question: "How is PrepLetter different from LeetCode?",
      answer: "While LeetCode is a problem bank, PrepLetter is a structured learning journey. We provide curated daily content, AI-generated explanations, email delivery for consistency, progress tracking, and a systematic curriculum designed specifically for gradual skill building."
    },
    {
      id: 9,
      question: "Is PrepLetter good for interview preparation?",
      answer: "PrepLetter is excellent for interview prep! Our systematic approach covers all major interview patterns, provides multiple solution strategies, and includes complexity analysis that's crucial for technical interviews. Many users have successfully landed positions at top tech companies using PrepLetter."
    },
    {
      id: 10,
      question: "How do I unsubscribe if needed?",
      answer: "You can unsubscribe at any time by clicking the unsubscribe link in any PrepLetter email, or by visiting your account settings on our platform. We make it easy to manage your subscription preferences."
    },
    {
      id: 11,
      question: "Can I suggest problems or topics?",
      answer: "We welcome community input! While our curriculum is carefully structured, we're always open to feedback and suggestions. You can reach out through our contact form or social media channels to share ideas for improving PrepLetter."
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section" id="faq">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">
            Everything you need to know about PrepLetter
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="faq-accordion">
              {faqData.map((faq, index) => (
                <div key={faq.id} className="faq-item">
                  <div 
                    className={`faq-question ${activeIndex === index ? 'active' : ''}`}
                    onClick={() => toggleAccordion(index)}
                  >
                    <h5 className="question-text">{faq.question}</h5>
                    <div className="question-icon">
                      <i className={`bi ${activeIndex === index ? 'bi-dash' : 'bi-plus'}`}></i>
                    </div>
                  </div>
                  <div className={`faq-answer ${activeIndex === index ? 'active' : ''}`}>
                    <div className="answer-content">
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="faq-cta">
          <div className="text-center">
            <h4 className="cta-title">Still have questions?</h4>
            <p className="cta-subtitle">We're here to help! Get in touch with our team.</p>
            <a href="mailto:hello@rolepilot.ai" className="btn btn-primary cta-button me-4">
              <i className="bi bi-envelope me-2"></i>
              Contact Support
            </a>
            <a href="https://discord.gg/fBcakTEcps" className="btn btn-primary cta-button me-4">
              <i className="bi bi-discord me-2"></i>
              Join Discord
            </a>
            <a href="https://www.linkedin.com/company/prepletter/" className="btn btn-primary cta-button me-4">
              <i className="bi bi-linkedin me-2"></i>
              Follow on LinkedIn
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
